import { useMessagesRepository } from '@Hooks/useRepository';
import { CashRegistersRepository } from '@Repositories/Messages';
import { isNullOrEmpty, isOk, useToasts } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useState } from 'react';

export function useTseClient(cashRegisterId: string, autoPing = true) {
    const [n, setN] = useState(0);
    const cashRegisters = useMessagesRepository(CashRegistersRepository);
    const { pushToast } = useToasts();

    const pingQuery = useQuery({
        queryFn: () => cashRegisters.pingTse(cashRegisterId),
        select: (result) => isOk(result),
        queryKey: ['tse', 'ping', cashRegisterId],
        enabled: autoPing && !isNullOrEmpty(cashRegisterId),
        refetchInterval: 60_000,
        retry: false,
    });

    const retriggerPing = useCallback(() => {
        void pingQuery.refetch();
        setN((n) => n + 1);
    }, [pingQuery]);

    const isPending = pingQuery.isPending;
    const isTseAvailable = pingQuery.data;

    useEffect(() => {
        if (isPending) {
            return;
        }
        if (isTseAvailable) {
            pushToast({
                title: 'TSE Client',
                message: 'TSE erreichbar!',
                variant: 'success',
            });
        } else {
            pushToast({
                title: 'TSE Client',
                message: 'TSE nicht erreichbar',
                variant: 'error',
            });
        }
    }, [isTseAvailable, isPending, pushToast, n]);

    return {
        isTseAvailable: isTseAvailable === true,
        pingTse: retriggerPing,
    };
}
